import './lineItemFooterSeparator.scss';

import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

interface LineItemFooterSeparatorProps {
    className?: string;
}

const bem = bemFactory.block('reqf-line-item-footer-separator');

/**
 * @deprecated Use redesigned component Divider instead
 */
const LineItemFooterSeparator: FC<LineItemFooterSeparatorProps> = (props) => {
    const { className } = props;

    return <div className={bem.add(className)()} />;
};

export default memo(LineItemFooterSeparator);
